import React, { useState } from 'react';
import { PercentIcon, CheckIcon, XIcon, TentIcon } from 'lucide-react';
type PromoCodeInputProps = {
  onApply: (code: string) => void;
  onClear: () => void;
  appliedCode?: string | null;
  isValid?: boolean;
  discount?: number | null;
};
export const PromoCodeInput: React.FC<PromoCodeInputProps> = ({
  onApply,
  onClear,
  appliedCode = null,
  isValid = false,
  discount = null
}) => {
  const [code, setCode] = useState('');
  const [isApplying, setIsApplying] = useState(false);
  const handleApply = () => {
    if (!code.trim()) return;
    setIsApplying(true);
    // Simulate API call to validate code
    setTimeout(() => {
      onApply(code);
      setIsApplying(false);
    }, 800);
  };
  if (appliedCode) {
    return <div className="bg-gradient-to-r from-amber-600/20 to-amber-700/20 border border-amber-500/30 rounded-lg p-4" data-id="element-4587" data-mp="kz85xwtkn64">
        <div className="flex items-center justify-between" data-id="element-4588" data-mp="2p8e19reqdztn">
          <div className="flex items-center" data-id="element-4589" data-mp="2l7ka8p5zs4wj">
            <div className="w-10 h-10 bg-amber-600/30 rounded-lg flex items-center justify-center mr-3" data-id="element-4590" data-mp="2m16pofk60pqt">
              {isValid ? <PercentIcon size={20} className="text-amber-500" data-id="element-4591" data-mp="2r0t4gtfn6e1q" /> : <XIcon size={20} className="text-red-500" data-id="element-4592" data-mp="2qy6y2x4hm4l3" />}
            </div>
            <div data-id="element-4593" data-mp="2czqjkk0dv9se">
              <div className="flex items-center" data-id="element-4594" data-mp="2d08ijoefk240">
                <TentIcon size={16} className="text-amber-500 mr-1.5" data-id="element-4595" data-mp="2h1c1wkvosg9z" />
                <span className="text-white font-medium" data-id="element-4596" data-mp="23ap3yuxr2uey">
                  Código de feria aplicado
                </span>
              </div>
              <div className="text-amber-300 text-sm mt-0.5" data-id="element-4597" data-mp="282gs6ytfoo1x">
                {isValid ? `"${appliedCode}" - ${discount}% de descuento aplicado` : `"${appliedCode}" - Código inválido o expirado`}
              </div>
            </div>
          </div>
          <button onClick={onClear} className="text-amber-300 hover:text-amber-200 bg-amber-800/30 hover:bg-amber-800/50 rounded-lg px-3 py-1.5 text-sm transition-colors" data-id="element-4598" data-mp="1y99emqoji1qr">
            Eliminar
          </button>
        </div>
      </div>;
  }
  return <div className="bg-blue-900/30 border border-blue-800/30 rounded-lg p-4" data-id="element-4599" data-mp="3r150409srmo7">
      <div className="flex items-center mb-3" data-id="element-4600" data-mp="3m8v3k1e6focy">
        <PercentIcon size={18} className="text-blue-400 mr-2" data-id="element-4601" data-mp="3m8247lhjs14u" />
        <h3 className="text-white font-medium" data-id="element-4602" data-mp="3h9ijfoeowve2">
          ¿Tienes un código promocional?
        </h3>
      </div>
      <div className="flex items-center gap-2" data-id="element-4603" data-mp="3d9zwkn3b6a8l">
        <div className="relative flex-1" data-id="element-4604" data-mp="dtl4z39hx19x">
          <input type="text" placeholder="Ingresa el código de feria" value={code} onChange={e => setCode(e.target.value)} className="w-full bg-blue-950/50 border border-blue-800/50 rounded-lg px-4 py-2.5 text-white placeholder-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-4605" data-mp="dsigt33k5cxp" />
        </div>
        <button onClick={handleApply} disabled={!code.trim() || isApplying} className={`${!code.trim() || isApplying ? 'bg-blue-700/50 text-blue-300 cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-700 text-white'} px-4 py-2.5 rounded-lg transition-colors flex items-center`} data-id="element-4606" data-mp="3vyemf71w3i7t">
          {isApplying ? <>
              <div className="animate-spin mr-2 h-4 w-4 border-2 border-blue-300 border-t-transparent rounded-full" data-id="element-4607" data-mp="103jso7qrev72"></div>
              Aplicando...
            </> : <>Aplicar</>}
        </button>
      </div>
    </div>;
};